<script setup>
// Campo de formulário da área administrativa: rótulo, controle e erro ligados
// por id, para o leitor de tela anunciar o erro junto do campo.
defineProps({
  id: { type: String, required: true },
  label: { type: String, required: true },
  modelValue: { type: [String, Number, Boolean], default: '' },
  type: { type: String, default: 'text' },
  required: { type: Boolean, default: false },
  error: { type: String, default: '' },
  hint: { type: String, default: '' },
  autocomplete: { type: String, default: 'off' },
})
defineEmits(['update:modelValue'])
</script>

<template>
  <div>
    <label :for="id" class="block text-sm font-medium text-up-navy">{{ label }}</label>
    <input
      :id="id"
      :type="type"
      :value="modelValue"
      :required="required"
      :autocomplete="autocomplete"
      :aria-describedby="error ? `${id}-erro` : hint ? `${id}-dica` : undefined"
      :aria-invalid="error ? 'true' : undefined"
      class="mt-1.5 w-full rounded-lg border px-3.5 py-2.5 text-sm text-up-navy outline-none focus:ring-2"
      :class="error
        ? 'border-up-orange focus:border-up-orange focus:ring-up-orange/30'
        : 'border-slate-300 focus:border-up-orange focus:ring-up-orange/30'"
      @input="$emit('update:modelValue', $event.target.value)"
    >
    <p v-if="hint && !error" :id="`${id}-dica`" class="mt-1 text-xs text-slate-500">{{ hint }}</p>
    <p v-if="error" :id="`${id}-erro`" class="mt-1 text-xs text-up-orange-dark">{{ error }}</p>
  </div>
</template>
